import { Component, OnInit, HostBinding, ViewChild, NgZone, AfterViewInit, ElementRef, ChangeDetectorRef, Optional, Inject, LOCALE_ID } from '@angular/core';
import { ProcessDesignerUIState } from '../../../../app/process-designer.uistate';
import { ExprEditMode, ExpressionService, InjectedType } from '@gsp-svc/expression';
import { HttpService } from '@ecp-caf/caf-common';
import { MessagerService } from '@farris/ui-messager';
import { VariablePerformerEntity } from '../../entities/variable-performer.entity';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../../../i18n/assets/lang.resource';

declare var System: any;
@Component({
  selector: 'app-variable-performer',
  templateUrl: './variable-performer.component.html',
  styleUrls: ['./variable-performer.component.css'],
  providers: [
     WfLocalePipe,
  ]
})
export class VariablePerformerComponent implements OnInit, AfterViewInit {
  @HostBinding('class')
  cls = 'd-flex flex-fill h-100';
  @ViewChild('inputGroup') inputGroup: ElementRef;
  showClearButton = false;
  editState = true;
  bindingData: { id?, name?} = {};
  inSuiteField: { name: string, value: string }[] = [];
  variableOrgTypes = [
    { name: this.localePipe.transform('component.variablePerformer.sys'), value: 'Sys' },
    { name: this.localePipe.transform('component.variablePerformer.administrative_staff'), value: 'Administrative_staff' },
  ];
  userTypeButtonNeedShow = false;
  personnelRelationShipTypes = [
    { name: this.localePipe.transform('component.variablePerformer.oneself'), value: 'oneself' },
  ];
  curOrgType = this.variableOrgTypes[0].value;
  relationShipType = this.designerUIState.scene !== 'inSuite' ? this.personnelRelationShipTypes[0].value : null;
  scene = this.designerUIState.scene;
  condition: string;
  users: VariablePerformerEntity[] = [];
  user: VariablePerformerEntity = new VariablePerformerEntity();
  constructor(
    private designerUIState: ProcessDesignerUIState,
    private expr: ExpressionService,
    private ngZone: NgZone,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
    private http?: HttpService,
    private message?: MessagerService,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
  }

  ngOnInit() {
    const url = '/api/runtime/wf/v1.0/reportingOrgType/hasAdminOrg';
    this.http.get(url).subscribe((data: any) => {
      this.userTypeButtonNeedShow = data;
      if (this.designerUIState.scene === 'inSuite') {
        this.userTypeButtonNeedShow = true;
        this.variableOrgTypes = [
          { name: this.localePipe.transform('component.variablePerformer.sys'), value: 'Sys' },
          { name: this.localePipe.transform('component.variablePerformer.administrative_staff'), value: 'Administrative_staff' },
          { name: this.localePipe.transform('component.variablePerformer.administrative_organization'), value: 'Administrative_organization' }
        ];
        this.getInSuiteField(this.user.varType ? this.user.varType : 'Sys');
      }
    });
  }

  ngAfterViewInit(): void {
    this.ngZone.runOutsideAngular(() => {
      this.inputGroup.nativeElement.addEventListener(
        'mouseenter',
        this.onMouseEnter.bind(this)
      );
      this.inputGroup.nativeElement.addEventListener(
        'mouseleave',
        this.onMouseLeave.bind(this)
      );
    });
  }
  onMouseEnter(event) {
    this.showClearButton = true;
    if (this.showClearButton) {
      this.toggleClearIcon(event, true);
    }
  }
  onMouseLeave(event) {
    this.showClearButton = false;
    this.toggleClearIcon(event, false);
  }
  private toggleClearIcon(event: any, isShow = false) {
    const str = isShow ? '' : 'none';
    const clearIcon = event.target.querySelector('.input-group-clear');
    if (clearIcon) {
      clearIcon.style.display = str;
    }
  }
  clear(data: any) {
    // 流程变量表达式编辑器清空
    this.bindingData = {};
    this.users = [];
    this.user = null;
    this.variableOrgTypes = [
      { name: this.localePipe.transform('component.variablePerformer.sys'), value: 'Sys' },
      { name: this.localePipe.transform('component.variablePerformer.administrative_staff'), value: 'Administrative_staff' },
    ];
    if (this.designerUIState.scene === 'inSuite') {
      this.variableOrgTypes = [
        { name: this.localePipe.transform('component.variablePerformer.sys'), value: 'Sys' },
        { name: this.localePipe.transform('component.variablePerformer.administrative_staff'), value: 'Administrative_staff' },
        { name: this.localePipe.transform('component.variablePerformer.administrative_organization'), value: 'Administrative_organization' }
      ];
    }
  }
  selectUsers(data: any) {
      this.showExprHelp();
  }
  editConditon() {
    // this.expr.clearContext();
    if (this.designerUIState.schemas.length > 0) {
      for (const schema of this.designerUIState.schemas) {
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerUIState.schemas[0].entityTypes && this.designerUIState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerUIState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    let context = new Array();
    context = this.designerUIState.addContext(context);
    if (this.designerUIState.subActivityContext.length > 0) {
      for (const variable of this.designerUIState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (this.designerUIState.activityComponentContext.length > 0) {
      for (const variable of this.designerUIState.activityComponentContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
    this.expr.setEditPattern(ExprEditMode.Conditional); // 表达式展现模式：默认简易版
    this.expr.addExpressionText(this.condition);
    this.expr.buildExpression().then((expressioninfo: string) => {
      this.condition = expressioninfo;
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }
  showExprHelp() {
    // this.expr.clearContext();
    this.expr.setEditPattern(ExprEditMode.Advanced);
    if (this.designerUIState.schemas.length > 0) {
      for (const schema of this.designerUIState.schemas) {
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerUIState.schemas[0].entityTypes && this.designerUIState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerUIState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    const context = new Array();
    if (this.designerUIState.participantContext.length > 0) {
      for (const variable of this.designerUIState.participantContext) {
        context.push(variable);
      }
    }
    if (this.designerUIState.subActivityContext.length > 0) {
      for (const variable of this.designerUIState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (this.designerUIState.processVariableContext.length > 0) {
      for (const variable of this.designerUIState.processVariableContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
    if (this.users.length > 0) {
      this.expr.addExpressionText(this.users[0].varValue ? this.users[0].varValue : this.users[0].performerId);
    } else {
      this.expr.addExpressionText('');
    }
    // 2023-6-13 编辑时表达式编辑器只读
    this.expr.buildExpression().then((expressioninfo: string) => {
      if (expressioninfo) {
        const user = new VariablePerformerEntity(expressioninfo, '', 'wf.VariableParticipantExpression');
        user.tag = 'expression';
        user.performerName = this.variableParticipantName(expressioninfo);
        user.name =  this.variableParticipantName(expressioninfo);
        user.varType = this.curOrgType;
        if (this.designerUIState.scene === 'inSuite') {
          user.relation = this.relationShipType;
        } else {
          user.relation = this.personnelRelationShipTypes[0].value;
        }
        if (this.variableParticipantName(expressioninfo) === '') {
          // 如果先勾选行政人员id，再选择上下文变量，则提示并将变量值类型置为1
          this.message.info(this.localePipe.transform('component.variablePerformer.cantUseContext'));
          this.curOrgType = this.variableOrgTypes[0].value;
        } else {
          this.users = [user];
          this.user = user;
        }
        for (const c of this.designerUIState.participantContext) {
          // 根据表达式中的函数名判断是否使用的是上下文变量,除三种特殊上下文变量其余放开限制
          if (user.performerId.indexOf(c.key) >= 0) {
            this.variableOrgTypes = [
              { name: this.localePipe.transform('component.variablePerformer.sys'), value: 'Sys' }];
            break;
          } else {
            this.variableOrgTypes = [
              { name: this.localePipe.transform('component.variablePerformer.sys'), value: 'Sys' },
              { name: this.localePipe.transform('component.variablePerformer.administrative_staff'), value: 'Administrative_staff' },
            ];
            if (this.designerUIState.scene === 'inSuite') {
              this.variableOrgTypes = [
                { name: this.localePipe.transform('component.variablePerformer.sys'), value: 'Sys' },
                { name: this.localePipe.transform('component.variablePerformer.administrative_staff'), value: 'Administrative_staff' },
                { name: this.localePipe.transform('component.variablePerformer.administrative_organization'), value: 'Administrative_organization' }
              ];
            }
          }
        }
      } else {
        this.users = [];
        this.user = null;
        this.variableOrgTypes = [
          { name: this.localePipe.transform('component.variablePerformer.sys'), value: 'Sys' },
          { name: this.localePipe.transform('component.variablePerformer.administrative_staff'), value: 'Administrative_staff' },
        ];
        if (this.designerUIState.scene === 'inSuite') {
          this.variableOrgTypes = [
            { name: this.localePipe.transform('component.variablePerformer.sys'), value: 'Sys' },
            { name: this.localePipe.transform('component.variablePerformer.administrative_staff'), value: 'Administrative_staff' },
            { name: this.localePipe.transform('component.variablePerformer.administrative_organization'), value: 'Administrative_organization' }
          ];
        }
      }
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }
  getPerformers() {
    if (this.user) {
      this.user.varValue = this.user.performerId ? this.user.performerId : this.user.varValue;
      this.user.name = this.user.performerName ? this.user.performerName : this.user.name;
      // this.user.name = this.getRealName(this.user);
      this.user.varType = this.curOrgType;
      this.user.relation = this.relationShipType;
      this.user.condition = this.condition ? this.condition : '';
    }
    return this.user;
  }
  // TODO: 变量参与者选多个值时名称只能显示一个，待调整
  // getRealName(user: any) {
  //   // 2023-6-15 计算是否是多值，排除表达式里自带的一个逗号
  //   let r = user.name;
  //   let id = user.varValue;
  //   let char = ',';
  //   let count = id.split(char).length - 1;
  //   if (count > 1) {
  //     r += ' 等';
  //   }
  //   return r;
  // }

  private variableParticipantName(expr: string): string {
    for (const c of this.designerUIState.participantContext) {
      if (expr.indexOf(c.key) > -1) {
        if (this.curOrgType !== 'Sys') { // 行政人员类型不允许使用上下文变量
          return '';
        }
        return c.name;
      }
    }
    for (const c of this.designerUIState.processVariableContext) {
      if (expr.indexOf(c.key) > -1) {
        return c.name;
      }
    }
    return JSON.parse(expr).expr;
  }
  orgTypeChange(data: any) {
    if (data === 'Sys') {
      this.curOrgType = this.variableOrgTypes[0].value;
    } else if (data === 'Administrative_staff') {
      this.curOrgType = this.variableOrgTypes[1].value;
    } else {
      this.curOrgType = this.variableOrgTypes[2].value;
    }
    // 如果是inSuite场景需要获取inSuite部门的负责人，分管领导等关系
    if (this.designerUIState.scene === 'inSuite') {
      this.getInSuiteField(data);
      this.relationShipType = null;
    } else {
      this.relationShipType = this.personnelRelationShipTypes[0].value;
    }
  }
  enabledStateChange(data: any) {
    this.relationShipType = data.value;
  }
  getInSuiteField(fieldType: string) {
    const url = `/api/runtime/wf/v1.0/dtProcDefs/getInSuiteFields/${fieldType}`;
    this.http.get(url).subscribe((field: any) => {
      this.inSuiteField = [];
      for (const f of field) {
        const type = {
          name: f.field_description,
          value: f.field
        };
        // 清空inSuiteField
        this.inSuiteField.push(type);
      }
    });
  }
}
